import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index'
import NotFound from '@/components/Common/not_found'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      // 会匹配所有路径
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: '404-NOTFOUND_斑马公司商城'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/pages/index/router/index.js